export const passwordValidator = (value: string): string | undefined => {
  if (typeof value !== 'string' || value.length === 0) {
    const message = 'Пароль не может быть пустым';
    return message;
  }
  return undefined;
};
